(function(){
    angular
        .module('appback')
        .directive('setClassWhenAtTop', setclassonscroll);

        setclassonscroll.$inject = ['$timeout','$window','GenerallabService'];
        function setclassonscroll($timeout,$window,GenerallabService){
        	var $win = angular.element($window); // wrap window object as jQuery object
            return {
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	var genLab = GenerallabService;
		            	genLab.topcomentarios[$attrs.id] = false;

		            	var topClass = $attrs.setClassWhenAtTop; // get CSS class from directive's attribute value
			            var existeModal = $('.modal-dialog').length;

			            $win.on('scroll', function (e) {
			            	//console.log(genLab)
			            	if(!genLab.topcomentarios[$attrs.id]){
				                genLab.topcomentarios[$attrs.id] = element.offset().top; // get element's top relative to the document
				            }
			                if ($win.scrollTop() >= genLab.topcomentarios[$attrs.id]) {
			                    element.addClass(topClass);
			                } else {
			                    element.removeClass(topClass);
			                }
				            
			            });

			            $('.modal-content').on('scroll', function (e) {
			            	//console.log(genLab)
			            	if(!genLab.topcomentarios[$attrs.id]){
				                genLab.topcomentarios[$attrs.id] = element.offset().top; // get element's top relative to the document
				            }
			                //console.log(offsetTop);
			            	//console.log($('.modal-content').scrollTop());
			            	//console.log(genLab.topcomentarios);
			            	if ($('.modal-content').scrollTop() >= (genLab.topcomentarios[$attrs.id]-$win.scrollTop())) {
			                    element.addClass(topClass);
			                } else {
			                    element.removeClass(topClass);
			                }
			            });
			        });
		        }
          }
      }
})();